<div *ngIf="showBanner"
    class="fixed bottom-0 left-0 right-0 z-[999] p-4 md:p-6 bg-gray-900 text-white shadow-lg animate-fade-in-up">
    <div class="flex flex-col md:flex-row items-center justify-between max-w-7xl mx-auto">
        <div class="flex-1 mb-4 md:mb-0 md:mr-8 text-center md:text-left">
            <h3 class="text-lg font-semibold mb-2">Política de Cookies</h3>
            <p class="text-sm text-gray-300">
                Utilizamos cookies estrictamente necesarias para mantener su sesión activa y segura.
                Estas cookies son obligatorias para el uso de la plataforma.
            </p>
        </div>
        <div class="flex flex-col sm:flex-row items-center gap-3">
            <a class="text-sm font-medium text-white hover:text-primary-500 underline transition-colors"
                [routerLink]="['/cookie-policy']">
                Leer más
            </a>
            <button mat-flat-button [color]="'primary'" (click)="accept()">
                Entendido
            </button>
        </div>
    </div>
</div>